import { render } from "./Index.vue?vue&type=template&id=32a9e2d2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=32a9e2d2&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=32a9e2d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a9e2d2"]])

export default __exports__